import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { createNullOption } from '@cas/components/inputs/dropdown-items/utils';
import {
  GeofenceHoldTimeModel,
  useListGeofenceHoldTimesQuery,
} from '@casops/store/apis/geofenceHoldTimesApi';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useHoldTimeOptions = (isGreater: boolean): DropdownItemProps<number | null>[] => {
  const { t } = useTranslation();

  const { data: holdTimes } = useListGeofenceHoldTimesQuery(undefined, {
    refetchOnMountOrArgChange: 120,
  });

  return useMemo<DropdownItemProps<number | null>[]>(() => {
    const nullOption = createNullOption(t);

    if (typeof holdTimes !== 'undefined') {
      const filteredItems = holdTimes.filter(item => item.isGreater === isGreater);

      const numberOptions: DropdownItemProps<number>[] = filteredItems.map(
        ({ id, time }: GeofenceHoldTimeModel) => ({
          key: id.toString(),
          value: id,
          stringValue: id.toString(),
          label: time.toString(),
        }),
      );

      return [nullOption, ...numberOptions];
    }

    return [nullOption];
  }, [t, holdTimes, isGreater]);
};

export default useHoldTimeOptions;
